// extracted by mini-css-extract-plugin
export default {"mainDiv":"TribalSupportCard_mainDiv__uQQHg","countDiv":"TribalSupportCard_countDiv__qyv5k"};